<script lang="ts">
import SectionPaymentMeansList from '@/generated/sections/SectionPaymentMeansList.vue';
import { storeSession, storePaymentMeans, storeRib } from '@/generated/stores';
import PaymentMeans, { PaymentMeansTypes } from '@/generated/classes/PaymentMeans';
import Section from '@/framework/base/classes/Section';
import SectionContainer from '@/framework/base/components/SectionContainer.vue';
import { Alerts } from '@/framework/base/helpers/Alerts';
import { ObjTypes } from '@/generated/classes/ObjTypes';
import Owner from '@/generated/classes/Owner';
import { ColumnFilter, ListChoix, ListFilter } from '@/generated/classes/ListData';
import Rib from '@/generated/classes/Rib';
import SectionRibExtend from './SectionRibExtend.vue';
import { defineComponent } from "vue";

export default defineComponent({
  extends: SectionPaymentMeansList,
  name: 'SectionPaymentMeansListExtend',
  components: { SectionContainer },
  data() {
    return {
      selectedRib: new Rib() as Rib,
    };
  },
  computed: {
    headers(): any {
      return [
        { text: "Moyen", value: 'label', cellClass: '', sortable: true },
        { text: 'Action(s)', width: '20%', value: 'action', cellClass: 'iterate-cell-class iterate-cell-action', sortable: false },
      ];
    },
    paymentMeansOwner(): Owner {
      const user = storeSession.connectedUser;
      let owner = new Owner();
      if (user) {
        owner.objId = user.clientId;
        owner.objType = ObjTypes.CLIENT;
      }
      if (!user && this.owner) {
        owner = this.owner;
      }
      return owner;
    },
    section(): Section {
      const section = new Section();
      section.component = SectionRibExtend;
      section.ressource = this.ressource;
      section.picto = 'SectionIdentitePicto';
      section.data = this.selectedRib;
      section.type = 'rib';
      section.autoSave = false;
      return section;
    },
    canAdd(): boolean {
      return true;
    },
    showSearch(): boolean {
      return false;
    },
  },
  created (): void {
    const allData = new ListFilter();
    allData.pageLimit = -1;
    storePaymentMeans.registerPaymentMeans(allData);
  },
  methods: {
    togglePaymentMeans(): void {
      this.reloadTable();
    },
    defaultFilter(): void {
      {
        const filter = new ColumnFilter();
        filter.name = "type";
        filter.sortAscending = true;
        const virement = new ListChoix();
        virement.value = PaymentMeansTypes.VIREMENT;
        filter.filters.push(virement);
        const prelevement = new ListChoix();
        prelevement.value = PaymentMeansTypes.RIB;
        filter.filters.push(prelevement);
        this.activeFilters.push(filter);
      }
      {
        const columnFilter = new ColumnFilter();
        columnFilter.name = "ownerType";
        columnFilter.staticFilter = true;
        const choix = new ListChoix();
        choix.value = this.paymentMeansOwner.objType;
        columnFilter.filters.push(choix);
        this.activeFilters.push(columnFilter);
      }
      {
        const columnFilter = new ColumnFilter();
        columnFilter.name = "ownerId";
        columnFilter.staticFilter = true;
        const choix = new ListChoix();
        choix.value = this.paymentMeansOwner.objId;
        columnFilter.filters.push(choix);
        this.activeFilters.push(columnFilter);
      }
    },
    saved(): void {
      this.reloadTable();
    },
    getLabel(name: string, item: number, obj: unknown): string {
      const paymentMeans = obj as PaymentMeans;
      let res = item == 0 || item == null ? '' : item.toString();
      if (name == 'type') {
        res = this.getType(paymentMeans);
      } else {
        const column = this.listConfig.find(a => a.name == name);
        if (column) {
          const choix = column.choix.find(a => a.value == item);
          if (choix) {
            res = choix.text;
          }
        }
      }
      res = res.replace('Prélèvement sur le compte N°', 'Compte N°')
      return res;
    },
    getType(item: PaymentMeans): string {
      let res = '';
      if (item.type == PaymentMeansTypes.RIB) {
        res = 'Prélèvement';
      }
      return res;
    },
    addItem(): void {
      const rib = storeRib.createNewRib();
      rib.owner = this.paymentMeansOwner;
      this.selectedRib = rib;
      this.dialogOpen = true;
    },
    updateItem(item: PaymentMeans): void {
      this.dialogOpen = true;
      const paymentMeans = storePaymentMeans.listPaymentMeans.find(a => a.id == item.id)
      if (paymentMeans) {
        const rib = storeRib.getRib(paymentMeans.typeId);
        this.selectedRib = rib;
      }
    },
    deleteItem(item: any) {
      Alerts.alertDelete().then((res) => {
        if (res) {
          storePaymentMeans.deletePaymentMeans(item);
        }
      });
    },
    selectItem(item: unknown): void { },
  },
});
</script>